import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT
});

axiosInstance.interceptors.request.use(async (config) => {
  await refreshToken();
  const credential = localStorage.getItem('credential');
  const token = credential ? JSON.parse(credential).id_token : null;
  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});

const refreshToken = async () => {
  const credential = localStorage.getItem('credential');
  const refreshToken = credential ? JSON.parse(credential).refresh_token : null;
  const expiresAt = credential ? JSON.parse(credential).expires_at : null;

  const currentTime = Math.floor(Date.now() / 1000);
  if (currentTime < expiresAt) {
    return;
  }

  const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/admin/auth/google/refresh`, { 
    method: "POST", 
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ refresh_token: refreshToken })
  });
  const resJson = await res.json();
  localStorage.setItem('credential', JSON.stringify({ refresh_token: refreshToken, expires_at: calculateExpiresAt(resJson.expires_in), ...resJson }));
}

export const calculateExpiresAt = (expiresIn) => {
  const currentTime = Math.floor(Date.now() / 1000);
  const expiresAt = currentTime + expiresIn - (5 * 60);
  return expiresAt;
}

export default axiosInstance;
